import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { useState } from "react";
import Flex from "../../../../../components/Flex";
import Text from "../../../../../components/Text";

interface AssessmentExportButtonProps {
  onClick: (v: "csv" | "pdf") => void;
  disabled: boolean;
}

const EXPORT_ITEM_LIST = [
  { label: "Export PDF", src: "/patient/export csv.svg", value: "pdf" },
  { label: "Export CSV", src: "/patient/export xls.svg", value: "csv" },
];

const AssessmentExportButton = ({
  onClick,
  disabled,
}: AssessmentExportButtonProps) => {
  const [curHoverEle, setCurHoverEle] = useState<string>();

  return (
    <PopupState variant="popover" popupId="create-navbar-button-menu">
      {(menuList) => (
        <>
          <Button
            variant="outlined"
            {...bindTrigger(menuList)}
            disabled={disabled}
          >
            <Flex alignItems={"center"}>
              <Text c={disabled ? "gray" : "black"}>Export</Text>
              {bindMenu(menuList).open ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )}
            </Flex>
          </Button>

          <Menu {...bindMenu(menuList)}>
            <Flex flexWrap={"wrap"} width={"14.5rem"} p={1} gap={1}>
              {EXPORT_ITEM_LIST?.map((it) => (
                <MenuItem
                  onMouseEnter={() => setCurHoverEle(it.label)}
                  sx={{
                    width: "6.5rem",
                    padding: 0.5,
                  }}
                  onClick={() => {
                    menuList.close();
                    onClick(it.value as "pdf" | "csv");
                  }}
                >
                  <Box
                    width={"100%"}
                    bgcolor={curHoverEle === it.label ? "#EFF6FF" : "#FAFAFA"}
                  >
                    <Flex flexDirection={"column"}>
                      <img
                        style={{ width: "3rem", height: "3rem" }}
                        src={it.src}
                        alt={it.label + " Image"}
                      />
                      <Typography>{it.label}</Typography>
                    </Flex>
                  </Box>
                </MenuItem>
              ))}
            </Flex>
          </Menu>
        </>
      )}
    </PopupState>
  );
};

export default AssessmentExportButton;
